import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard/modern',
    title: 'Dashboard',
    icon: 'mdi mdi-view-dashboard',
    class: '',
    ddclass: '',
    extralink: false,
    submenu: []
  },  
  {
    path: '',
    title: 'Payment',
    icon: 'mdi mdi-view-dashboard',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/payment/paymentDetails',
        title: 'Payment Details',
        icon: 'mdi mdi-adjust',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      
      // {
      //   path: '/payment/paymentInvoice',
      //   title: 'Payment Invoice',
      //   icon: 'mdi mdi-adjust',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },

    ]
  },
  

  {
    path: '',
    title: 'Masters',
    icon: 'mdi mdi-view-dashboard',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      // {
      //   path: '/ps/categoryDetails',
      //   title: 'Category Details',
      //   icon: 'mdi mdi-adjust',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },
      {
        path: '/ps/companyMaster',
        title: 'Company Master',
        icon: 'mdi mdi-account',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ps/shopMaster',
        title: 'Shop Master',
        icon: 'mdi mdi-account',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      // {
      //   path: '/ps/companyPolicy',
      //   title: 'Company Policy',
      //   icon: 'mdi mdi-account',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },
      {
        path: '/ps/staffDetails',
        title: 'Employee Master',
        icon: 'mdi mdi-account',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      // {
      //   path: '/ps/designDetails',
      //   title: 'Design Makers',
      //   icon: 'mdi mdi-account',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },
      // {
      //   path: '/ps/orderAssigningProcess',
      //   title: 'Order Assigning Process',
      //   icon: 'mdi mdi-account',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },
      //Admin Console Panel Foot Logics Added on 21/10/2023
      {
        path: '/ps/productMaster',
        title: 'Product Master',
        icon: ' fab fa-product-hunt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ps/homeBannerPage',
        title: 'Home Banner',
        icon: ' fas fa-image',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ps/aboutCompany',
        title: 'About Company',
        icon: 'far fa-building',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ps/privacyPolicy',
        title: 'Privacy Policy',
        icon: 'far fa-building',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ps/refundPolicy',
        title: 'Refund Policy',
        icon: 'far fa-building',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ps/termsCondition',
        title: 'Terms & Conditions',
        icon: 'far fa-building',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ps/productCategoryMaster',
        title: 'Product Category',
        icon: ' far fa-list-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: "/ps/supplierMaster",
        title: "Supplier Master",
        icon: "fas fa-user",
        class: "",
        ddclass: "",
        extralink: false,
        submenu: [],
      },
      
      {
        path: '/ps/footcomplaintstypeComponent',
        title: 'Foot Complaints Type',
        icon: ' far fa-list-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      
      
    ]
  },
  {
    path: '',
    title: 'Order Management',
    icon: 'mdi mdi-view-dashboard',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/order/orderDetails',
        title: 'Order Details',
        icon: 'mdi mdi-adjust',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      
      // {
      //   path: '/payment/paymentInvoice',
      //   title: 'Payment Invoice',
      //   icon: 'mdi mdi-adjust',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },

    ]
  },
  // {
  //   path: '',
  //   title: 'Invoice',
  //   icon: 'mdi mdi-view-dashboard',
  //   class: 'has-arrow',
  //   ddclass: '',
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: '/invoice/paymentInvoice',
  //       title: 'Payment Invoice',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       ddclass: '',
  //       extralink: false,
  //       submenu: []
  //     },


  //   ]
  // },
  //Added by abubakkar on 03/11/2023
  {
    path: '',
    title: 'User Management',
    icon: 'mdi mdi-view-dashboard',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      
      {
        path: '/user-management/userDetails',
        title: 'User Details',
        icon: 'mdi mdi-adjust',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      // {
      //   path: '/user-management/userProfile',
      //   title: 'User Profile',
      //   icon: 'mdi mdi-adjust',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },
      
      
      // {
      //   path: '/payment/paymentInvoice',
      //   title: 'Payment Invoice',
      //   icon: 'mdi mdi-adjust',
      //   class: '',
      //   ddclass: '',
      //   extralink: false,
      //   submenu: []
      // },

    ]
  },
  {
    path: "",
    title: "Inventory",
    icon: "mdi mdi-view-dashboard",
    class: "has-arrow",
    ddclass: "",
    extralink: false,
    submenu: [
          {
        path: "/purchase/stockEntry",
        title: "Stock Entry",
        icon: "mdi mdi-inbox-arrow-down",
        class: "",
        ddclass: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Reports",
    icon: "mdi mdi-view-dashboard",
    class: "has-arrow",
    ddclass: "",
    extralink: false,
    submenu: [
      
     
      {
        path: "/reports/stockDetailsReport",
        title: "Stock (IN) Details Report",
        icon: "mdi mdi-file-document-box",
        class: "",
        ddclass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/reports/stockSummaryReport",
        title: "Stock (IN) Summary Report",
        icon: "mdi mdi-file-document-box",
        class: "",
        ddclass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/reports/currentStockReport",
        title: "Current Stock Report",
        icon: "mdi mdi-file-document-box",
        class: "",
        ddclass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/reports/invoiceDetailsReport",
        title: "Invoice Details Report",
        icon: "mdi mdi-file-document-box",
        class: "",
        ddclass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/reports/invoiceSummaryReport",
        title: "Invoice Summary Report",
        icon: "mdi mdi-file-document-box",
        class: "",
        ddclass: "",
        extralink: false,
        submenu: [],
      },

      
    ],
  },

];
